<template>
	<PopUp
		title="Upgrade auf PRO"
		ok-text="Jetzt upgraden"
		:ok-disabled="!dataValid || loading"
		:hide-cancel="loading"
		:hide-close="loading"
		size="lg"
		@ok="upgrade"
		@hidden="$emit('hidden')"
	>
		<Loading v-if="loadingUpgradeInfos" text="Lade Daten..."/>
		<Loading v-else-if="upgrading" text="Upgrade läuft..."/>
		<template v-else>
			<!-- should not happen? -->
			<div v-if="!upgradeInfos.canUpgrade">Du hast bereits das beste Paket, ein Upgrade ist derzeit nicht
				möglich!
			</div>
			<template v-else>
				<div v-if="upgradeInfos.feeComprehensive">
					<div>
						Für <b>{{ upgradeInfos.feeComprehensive }} Token</b> kannst du das Stellenprofil auf PRO
						upgraden. Damit werden die Daten für alle Kandidaten in diesem Stellenprofil freigeschalten.
					</div>

					<div v-if="!upgradeInfos.canAffordComprehensive" class="mt-2">
						<JonInfo>
							<template #message>
								<div>Dein Guthaben reicht leider nicht aus.</div>
								<div class="mt-2">
									<a href="/kundenbereich/verrechnung">Klicke hier um Token zu kaufen</a>
								</div>
							</template>
						</JonInfo>
					</div>
				</div>
				<!--<div v-if="upgradeInfos.feeApplicant" class="mt-2">
					<div>
						Um nur die Infos dieses einzelnen Kandidaten für das Stellenprofil freizuschalten, kannst du
						dies
						für <b>{{ upgradeInfos.feeApplicant }} Token</b> machen.
					</div>
					<div v-if="!upgradeInfos.canAffordApplicant" class="error mt-2">
						Dein Guthaben reicht leider nicht aus. <a href="/kundenbereich/verrechnung">Klicke hier um
						Token zu kaufen</a>.
					</div>
				</div>-->
				<FormGroup
					v-if="typeOptions"
					label="Wähle das gewünschte Upgrade:"
					:label-classes="['font-weight-extra-bold']"
					class="mt-3"
				>
					<RadioGroup
						v-model="type"
						:options="typeOptions"
					/>
				</FormGroup>
			</template>
		</template>
	</PopUp>
</template>

<script>
import FormGroup from "@/vue/common/form/Group";
import Select from "@/vue/common/form/Select";
import PopUp from "@/vue/common/PopUp";
import Get from "@/api/customer/job-profile/permission/Get";
import Upgrade from "@/api/customer/job-profile/permission/Upgrade";
import Loading from "@/vue/common/Loading";
import {isDefined} from "@/helper/Value";
import RadioGroup from "@/vue/common/form/RadioGroup.vue";
import JonInfo from "@/vue/common/JonInfo.vue";

const TYPE_COMPREHENSIVE = 'comprehensive';
const TYPE_APPLICANT = 'applicant';

export default {

	components: {
		JonInfo,
		RadioGroup,
		PopUp,
		Loading,
		Select,
		FormGroup,
	},

	props: {
		jobProfileId: {
			type: String,
			required: true,
		},
		pseudonymId: {
			type: String,
			required: false,
		},
	},

	mounted ()
	{
		this.loadUpgradeInfos();
	},

	data ()
	{
		return {
			loadingUpgradeInfos: true,
			upgradeInfos: null,
			type: undefined,
			upgrading: false,
		};
	},

	computed: {
		loading ()
		{
			return this.loadingUpgradeInfos || this.upgrading;
		},
		typeOptions ()
		{
			let options = [];

			if (isDefined(this.upgradeInfos?.feeComprehensive) && this.upgradeInfos?.canAffordComprehensive)
			{
				let tokenText = this.upgradeInfos.feeComprehensive === 0
					? 'Kostenlos'
					: (this.upgradeInfos.feeComprehensive + ' Token');

				options.push({
					value: TYPE_COMPREHENSIVE,
					text: 'Stellenprofil jetzt upgraden (' + tokenText + ' Token)'
				});
			}

			/*if (isDefined(this.upgradeInfos?.feeApplicant) && this.upgradeInfos?.canAffordApplicant)
			{
				options.push({
					value: TYPE_APPLICANT,
					text: 'Nur diesen Kandidaten upgraden (' + this.upgradeInfos.feeApplicant + ' Token)'
				});
			}*/

			return options.length > 0
				? options
				: null;
		},
		typeValid ()
		{
			return isDefined(this.type);
		},
		dataValid ()
		{
			return this.typeValid;
		},
	},

	methods: {
		async loadUpgradeInfos ()
		{
			this.loadingUpgradeInfos = true;

			const response = await new Get()
				.setJobProfileId(this.jobProfileId)
				.setPseudonymId(this.pseudonymId)
				.call();

			this.upgradeInfos = response.data;

			this.loadingUpgradeInfos = false;
		},
		async upgrade ()
		{
			this.upgrading = true;

			try
			{
				const upgrade = new Upgrade()
					.setJobProfileId(this.jobProfileId);

				/*if (this.type === TYPE_APPLICANT)
				{
					upgrade.setPseudonymId(this.pseudonymId);
				}*/

				await upgrade.call();

				this.$emit('upgrade');
			}
			catch (e)
			{

			}

			this.upgrading = false;
		}
	},
}
</script>
